const Terms = () => {
  return (
    <div id="main-content-target" className="terms-page">
      <h1 className="text-danger">TERMS OF USE FOR HEALTHCARE PROVIDERS</h1>

      <p className="text-justify mt-8">
        These terms of use (the “Terms of Use”) and the terms and conditions contained in the Registration Form (defined below) constitute an agreement between you as a healthcare provider (“Healthcare Provider”, "you," or "your") and Health4U Solutions Sdn Bhd (1148648-W) (“Health4U,” “we,” “our” or “us”), the operator of BOOKDOC.com and related websites, services and mobile applications provided by us.<br/><br/>

        By using or otherwise accessing the Services (defined below), you agree to the terms of this Agreement. If you do not agree with this Agreement, you must refrain from accessing or using the Services. Please note that we offer the Services "AS IS" and without warranties.<br/><br/>

        In consideration of the mutual promises contained the parties hereto agree as follows.
      </p>

      <ul className="term__list-contents">
        <li>
          <span className="indicator">1.</span>
          <span className="term__sub-title"><p>definitions & interpretation</p></span>
        </li>

        <li>
          <span className="indicator">1.1</span>
          <span className="term__content">
            <p>In addition to the above expressions, the following definitions in this Agreement have the following meanings which meanings shall extend to all grammatical variations and cognate expressions of the words so defined, where the context so requires:</p>
            <p><b>“Access ID”</b>means any user IDs, passwords which we may provide to you to enable you to activate, access and use the Services.</p>
            <p><b>“Administrative Charges”</b>means the fee for the Services to be provided under this Agreement as specified in the Registration Form.</p>
            <p><b>“Business Day”</b>means a day (excluding Saturdays) on which banks are open for business in Kuala Lumpur and on which transactions in interbank deposits are carried out in the Kuala Lumpur interbank money market.</p>
            <p><b>“Commencement Date”</b>means the commencement date for the Services as specified in the Registration Form.</p>
            <p><b>“Documentation”</b>means the operating manuals user instructions technical literature on-line help and other documentation and all other related materials made available online to you by us for aiding your access and use of the Services.</p>
            <p><b>“Healthcare Provider Staff”</b>means your employees, agents and any other third parties who are authorised by you to use the Services.</p>
            <p><b>“Services”</b>collectively refers to: (1) the BookDoc website<a href="https://www.bookdoc.com">&nbsp;https://www.bookdoc.com</a><b>&nbsp;(“Site”)</b>; (2) the BookDoc-branded applications for mobile, tablet or other handheld computing devices<b>(“Application”)</b>; (3) the online healthcare provider reservation services available on the Site and Application as more particularly described in Clause 3 below<b>(“Appointment”).</b></p>
            <p><b>“Registration Form”</b>means the form which shall be completed by Healthcare Providers in order to use the Services.</p>
            <p><b>“Term”</b>means the duration for the Services as specified in the Registration Form.</p>
            <p><b>“User”</b>means a natural person registered with the Services who utilises the same in order to make Appointments. For the avoidance of doubt, “User” also refers to: (1) a parent or guardian who makes Appointments for a person who is under the age of eighteen (18); and (2) an elderly person whose name was used to make the Appointment notwithstanding that he or she was not physically involved in the actual Appointment making process.</p>
            <p><b>“Virus”</b>means anything or device (including any software, code, file or programme) which may or may threaten to: prevent, impair or otherwise adversely affect the operation of any computer software, hardware or network, any telecommunications service, equipment or network or any other service or device; prevent, impair or otherwise adversely affect access to or the operation of any programme or data, including the reliability of any programme or data (whether by re-arranging, altering or erasing the programme or data in whole or part or otherwise); or adversely affect the user experience, including worms, trojan horses, malware, viruses and other similar things or devices.</p>
          </span>
        </li>

        <li>
          <span className="indicator">1.2</span>
          <span className="term__content">
            <p>The following rules apply unless the context requires otherwise:</p>

            <ul>
              <li>
                <span className="indicator indicator--sub">(a)</span>
                <span className="term__content">
                  <p>headings are for convenience only and shall not affect the interpretation hereof;</p>
                </span>
              </li>
              <li>
                <span className="indicator indicator--sub">(b)</span>
                <span className="term__content">
                  <p>the singular includes the plural and vice versa;</p>
                </span>
              </li>
              <li>
                <span className="indicator indicator--sub">(c)</span>
                <span className="term__content">
                  <p>words denoting any gender include all genders;</p>
                </span>
              </li>
              <li>
                <span className="indicator indicator--sub">(d)</span>
                <span className="term__content">
                  <p>if a word or phrase is defined, its other grammatical forms have a corresponding meaning;</p>
                </span>
              </li>
              <li>
                <span className="indicator indicator--sub">(e)</span>
                <span className="term__content">
                  <p>save where the contrary is indicated, any reference to this Agreement or any other agreement or document shall be construed as a reference to this Agreement or, as the case may be, such other agreement or document as the same may have been or may from time to time be amended, varied, novated or supplemented;</p>
                </span>
              </li>
              <li>
                <span className="indicator indicator--sub">(f)</span>
                <span className="term__content">
                  <p>any reference to a "person" shall be construed as a reference to any person, firm, company, corporation, government, state or agency of a state or any association or partnership (whether or not having separate legal personality) or one or more of the foregoing;</p>
                </span>
              </li>
              <li>
                <span className="indicator indicator--sub">(g)</span>
                <span className="term__content">
                  <p>any reference to a Party to this Agreement or another agreement or document includes a reference to the Party’s successors, permitted nominees and assigns (and where applicable, the Party’s personal representatives);</p>
                </span>
              </li>
              <li>
                <span className="indicator indicator--sub">(h)</span>
                <span className="term__content">
                  <p>unless the context otherwise requires, reference to any Clause is to a clause of this Agreement;</p>
                </span>
              </li>
              <li>
                <span className="indicator indicator--sub">(i)</span>
                <span className="term__content">
                  <p>any reference to a statutory provision shall include such provision and any regulations made in pursuance thereof as may from time to time be modified or re-enacted whether before or after the date of this Agreement so far as such modification or re-enactment applies or is capable of applying to any transaction entered into prior to completion and (so far as liability thereunder may exist or can arise) shall include also any past statutory provisions or regulations (as from time to time modified or re-enacted) which such provisions or regulations have directly or indirectly replaced;</p>
                </span>
              </li>
              <li>
                <span className="indicator indicator--sub">(j)</span>
                <span className="term__content">
                  <p>any reference to proceedings includes litigation, arbitration or investigation;</p>
                </span>
              </li>
              <li>
                <span className="indicator indicator--sub">(k)</span>
                <span className="term__content">
                  <p>the meaning of general words is not limited by specific examples introduced by “including” or “for example” or similar expressions;</p>
                </span>
              </li>
              <li>
                <span className="indicator indicator--sub">(l)</span>
                <span className="term__content">
                  <p>the words "hereof", "herein", "hereon" and "hereunder" and words of similar import refer to this Agreement as a whole and not to any particular provision of this Agreement;</p>
                </span>
              </li>
              <li>
                <span className="indicator indicator--sub">(m)</span>
                <span className="term__content">
                  <p>a reference to a judgement includes an order, injunction, decree, determination or award of any court or tribunal;</p>
                </span>
              </li>
              <li>
                <span className="indicator indicator--sub">(n)</span>
                <span className="term__content">
                  <p>if a payment or other act must be made or done on a day that is not a Business Day, then it must be made or done on the next Business Day;</p>
                </span>
              </li>
              <li>
                <span className="indicator indicator--sub">(o)</span>
                <span className="term__content">
                  <p>unless the context otherwise requires, a reference to time is to Malaysia time; and</p>
                </span>
              </li>
              <li>
                <span className="indicator indicator--sub">(p)</span>
                <span className="term__content">
                  <p>any term condition stipulation provision covenant or undertaking of this Agreement which is illegal, prohibited or unenforceable in any jurisdiction shall as to such jurisdiction be fully severable and ineffective to the extent of such illegality, voidness, prohibition or unenforceability without invalidating the remaining provisions hereof which shall not be affected by the illegal, invalid or unenforceable provision or by its severance herefrom. This Agreement shall be construed and enforced as if such illegal, invalid or unenforceable provision had never comprised a part hereof. Any such illegality, voidness, prohibition or unenforceability in any jurisdiction shall not invalidate or render illegal, void or unenforceable any such term condition stipulation provision covenant or undertaking in any other jurisdiction.</p>
                </span>
              </li>
            </ul>
          </span>
        </li>
      </ul>

      <ul className="term__list-contents">
        <li>
          <span className="indicator">2.</span>
          <span className="term__sub-title"><p>services</p></span>
        </li>

        <li>
          <span className="indicator">2.1</span>
          <span className="term__content">
            <p>The Services shall commence on the Commencement Date and shall continue for the Term and thereafter shall be renewed for the period stated in the Registration Form until terminated in accordance with Clause 15 or as otherwise provided in this Agreement.</p>
          </span>
        </li>

        <li>
          <span className="indicator">2.2</span>
          <span className="term__content">
            <p>You shall have a right to terminate the Services upon providing thirty (30) days’ notice to us.</p>
          </span>
        </li>
      </ul>

      <ul className="term__list-contents">
        <li>
          <span className="indicator">3.</span>
          <span className="term__sub-title"><p>appointment</p></span>
        </li>

        <li>
          <span className="indicator">3.1</span>
          <span className="term__content">
            <p>The Services enable the User to make an Appointment with you. In response to the User’s online request for an Appointment with you through the Site or Application, we will contact you via the Services accessible by you in the event that you have confirmed your status as available during the time requested by the User.</p>
          </span>
        </li>

        <li>
          <span className="indicator">3.2</span>
          <span className="term__content">
            <p>In such event the User is considered to have a confirmed Appointment save and except if: (a) the User cancels the Appointment or (b) you cancel the Appointment.</p>
          </span>
        </li>

        <li>
          <span className="indicator">3.3</span>
          <span className="term__content">
            <p>If, for any reason, you have made any errors with regard to your availability when using the Services, you shall directly notify and resolve the error with any or all Users affected by your error and notify us of the outcome. For the avoidance of doubt, you shall be solely responsible for your dealings with the Users and any and all losses or damages incurred or suffered by the Users arising out of or in connection with the User’s dealings with or visit to your clinic or from any of your goods or services or in relation to the use of the Services. You agree to take full responsibility of the doctor-patient relationship during the Appointment and you shall indemnify us from any claim by the Users for failure to do so.</p>
          </span>
        </li>
      </ul>

      <ul className="term__list-contents">
        <li>
          <span className="indicator">4.</span>
          <span className="term__sub-title"><p>rights granted</p></span>
        </li>

        <li>
          <span className="indicator">4.1</span>
          <span className="term__content">
            <p>We hereby grant to you a non-exclusive, non-transferable licence to access and use the Services during the Term subject to the terms and conditions contained herein. In this regard, you are permitted to allow the Healthcare Provider Staff to access and use the Services provided that you undertake that you shall ensure the Healthcare Provider Staff comply with the terms and conditions of this Agreement.</p>
          </span>
        </li>

        <li>
          <span className="indicator">4.2</span>
          <span className="term__content">
            <p>You shall use the Services for your own internal business purposes only. You shall not permit any third party who is not authorised by you to access and use the Services nor access and use the Services on behalf of or for the benefit of any third party in any way whatsoever.</p>
          </span>
        </li>

        <li>
          <span className="indicator">4.3</span>
          <span className="term__content">
            <p>You shall not use the Site or Application in any manner that could damage, disable, overburden, or impair our services or networks or interfere with any other party’s use and enjoyment of the Site or Application.</p>
          </span>
        </li>

        <li>
          <span className="indicator">4.4</span>
          <span className="term__content">
            <p>You may not attempt to gain unauthorized access to any of the Services, user accounts, or computer systems or networks, through hacking, password mining or any other means. You may not accumulate or index, directly or indirectly, any content or portion of the Site, Application and/or Services for any purpose whatsoever.</p>
          </span>
        </li>
      </ul>

      <ul className="term__list-contents">
        <li>
          <span className="indicator">5.</span>
          <span className="term__sub-title"><p>payment</p></span>
        </li>

        <li>
          <span className="indicator">5.1</span>
          <span className="term__content">
            <p>In consideration of the Services provided, the Administrative Charges shall be payable upon your selection of one of the options stated in the Registration Form.</p>
          </span>
        </li>

        <li>
          <span className="indicator">5.2</span>
          <span className="term__content">
            <p>The Administrative Charges are inclusive of all duties and taxes which shall be paid by you at the rate and in the manner prescribed by law.</p>
          </span>
        </li>
      </ul>

      <ul className="term__list-contents">
        <li>
          <span className="indicator">6.</span>
          <span className="term__sub-title"><p>access id</p></span>
        </li>

        <li>
          <span className="indicator">6.1</span>

          <span className="term__content">
            <p>We shall provide you with an Access ID to access and use the Services. You shall at all times be responsible for maintaining and protecting the security and confidentiality of the Access ID. In this regard, you shall:</p>

            <ul>
              <li>
                <span className="indicator indicator--sub">(a)</span>
                <span className="term__content">
                  <p>be solely responsible for all access to and use of the Services via the Access ID; and</p>
                </span>
              </li>
              <li>
                <span className="indicator indicator--sub">(b)</span>
                <span className="term__content">
                  <p>shall inform us immediately of any possible misuse or unauthorised access to or use of the Services via the Access ID.</p>
                </span>
              </li>
            </ul>
          </span>
        </li>

        <li>
          <span className="indicator">6.2</span>
          <span className="term__content">
            <p>Not with standing that you are only allowed one user account you are entitled to authorise one or more Healthcare Provider Staff provided that such Healthcare Provider Staff comply with the Services terms of use herein. We may charge you a fee for any additional account and/or subsequent request for your Access ID including, but not limited to, a request to reset your Access ID password.</p>
          </span>
        </li>
      </ul>

      <ul className="term__list-contents">
        <li>
          <span className="indicator">7.</span>
          <span className="term__sub-title"><p>proprietary rights</p></span>
        </li>

        <li>
          <span className="indicator">7.1</span>
          <span className="term__content">
            <p>Save and except for the text, graphics, logos, icons, sound recordings or video recordings, supplied to us by or on behalf of you which we are required to generate, process, store or transmit pursuant to this Agreement<b>(“Healthcare Provider Content”)</b>, the copyright and other intellectual property rights of similar nature (including any modifications made thereto) in the Services (including text, graphics, logos, icons, sound recordings, video recordings and software) are and shall remain our property or our suppliers and we reserve the right to provide the Services and/or grant licences to access and use the Services to third parties.</p>
          </span>
        </li>

        <li>
          <span className="indicator">7.2</span>
          <span className="term__content">
            <p>You shall notify us in writing immediately if you become aware of any unauthorised access or use of the whole or any part of the Services by any person.</p>
          </span>
        </li>

        <li>
          <span className="indicator">7.3</span>
          <span className="term__content">
            <p>If you use any of our trademarks, rights in internet domain names and website addresses, other rights in trade names and similar intellectual property rights of similar nature<b>(“Marks”)</b>in reference to our activities, products or services, you shall include a statement attributing that Mark to us. In this regard, you shall not use any of the Marks:</p>

            <ul>
              <li>
                <span className="indicator indicator--sub">(a)</span>
                <span className="term__content">
                  <p>in or as the whole or part of your own trademarks;</p>
                </span>
              </li>
              <li>
                <span className="indicator indicator--sub">(b)</span>
                <span className="term__content">
                  <p>in connection with activities, products or services which are not ours;</p>
                </span>
              </li>
              <li>
                <span className="indicator indicator--sub">(c)</span>
                <span className="term__content">
                  <p>in a manner which may be confusing, misleading or deceptive; and/or</p>
                </span>
              </li>
              <li>
                <span className="indicator indicator--sub">(d)</span>
                <span className="term__content">
                  <p>in a manner which disparages or brings disrepute to the reputation and/or our business or our information, products or services (including the Services).</p>
                </span>
              </li>
            </ul>

            <p>Where required by law and/or to ensure your compliance with this Clause, you will permit us to check the access and use of the Services by you and the Healthcare Provider Staff at all reasonable times and for that purpose.</p>
          </span>
        </li>

        <li>
          <span className="indicator">7.4</span>
          <span className="term__content">
            <p>You hereby grant, or shall procure the direct grant, to us of a non-exclusive and non-transferable licence to load, execute, store, transmit, display, copy, publish, distribute, modify, adapt, enhance, reverse compile, decode, translate, or otherwise utilise the Healthcare Provider Content for any purpose relating to the Services or to the exercise of our business or function, including the right to sub-licence the Healthcare Provider Content to third parties providing services to us.</p>
          </span>
        </li>
      </ul>

      <ul className="term__list-contents">
        <li>
          <span className="indicator">8.</span>
          <span className="term__sub-title"><p>confidentiality</p></span>
        </li>

        <li>
          <span className="indicator">8.1</span>
          <span className="term__content">
            <p>You undertake to treat as confidential and keep secret all confidential information contained or embodied in the Services, the Documentation and all confidential information conveyed to you<b>(“Confidential Information”)</b>provided that this Clause shall not extend to information which:</p>

            <ul>
              <li>
                <span className="indicator indicator--sub">(a)</span>
                <span className="term__content">
                  <p>was rightfully in your possession prior to the commencement of the negotiations leading to this Agreement; or</p>
                </span>
              </li>
              <li>
                <span className="indicator indicator--sub">(b)</span>
                <span className="term__content">
                  <p>is already public knowledge.</p>
                </span>
              </li>
            </ul>
          </span>
        </li>

        <li>
          <span className="indicator">8.2</span>
          <span className="term__content">
            <p>You shall not without our prior written consent divulge any part of the Confidential Information to any person except:</p>

            <ul>
              <li>
                <span className="indicator indicator--sub">(a)</span>
                <span className="term__content">
                  <p>the Healthcare Provider Staff; and</p>
                </span>
              </li>
              <li>
                <span className="indicator indicator--sub">(b)</span>
                <span className="term__content">
                  <p>your auditors and any other persons or bodies having a right, duty or obligation to know your business and then only in pursuance of such right, duty or obligation.</p>
                </span>
              </li>
            </ul>
          </span>
        </li>

        <li>
          <span className="indicator">8.3</span>
          <span className="term__content">
            <p>You undertake to ensure that the persons and entities mentioned in Clause 8.2 are made aware prior to the disclosure of any part of the Confidential Information that the same is confidential and that they owe a duty of confidence to us. You shall indemnify us against any loss or damage which we may sustain or incur as a result of the persons and bodies failing to comply with such undertaking.</p>
          </span>
        </li>

        <li>
          <span className="indicator">8.4</span>
          <span className="term__content">
            <p>You shall promptly notify us if you become aware of any breach of confidence by any person to whom you divulge all or any part of the Confidential Information and shall give us all reasonable assistance in connection with any proceedings which we may institute against such person for breach of confidence.</p>
          </span>
        </li>

        <li>
          <span className="indicator">8.5</span>
          <span className="term__content">
            <p>Any information which you transmit to us is transmitted at your own risk. Nevertheless, once we receive your transmission, we will take reasonable steps to preserve the security of such information. You acknowledge the sole responsibility for and assume all risks arising from your access and use of the Services.</p>
          </span>
        </li>

        <li>
          <span className="indicator">8.6</span>
          <span className="term__content">
            <p>The foregoing obligations as to confidentiality shall remain in full force and effect notwithstanding any termination of this Agreement.</p>
          </span>
        </li>
      </ul>

      <ul className="term__list-contents">
        <li>
          <span className="indicator">9.</span>
          <span className="term__sub-title"><p>security and prohibited activities</p></span>
        </li>

        <li>
          <span className="indicator">9.1</span>
          <span className="term__content">
            <p>You shall during the Term:</p>

            <ul>
              <li>
                <span className="indicator indicator--sub">(a)</span>
                <span className="term__content">
                  <p>effect and maintain adequate security measures to safeguard the Services from access or use by any unauthorised person;</p>
                </span>
              </li>
              <li>
                <span className="indicator indicator--sub">(b)</span>
                <span className="term__content">
                  <p>protect the confidentiality of your Access ID and the safety and security of any computer, mobile phone and/or any other equipment and/or hardware you use to access the Services;</p>
                </span>
              </li>
              <li>
                <span className="indicator indicator--sub">(c)</span>
                <span className="term__content">
                  <p>not access, store, distribute or transmit any Virus, or any material during the course of its use of the Services that:</p>

                  <ul>
                    <li>
                      <span className="indicator indicator--sub">(i)</span>
                      <span className="term__content">
                        <p>is unlawful, harmful, threatening, defamatory, obscene, infringing, harassing or racially or ethnically offensive;</p>
                      </span>
                    </li>
                    <li>
                      <span className="indicator indicator--sub">(ii)</span>
                      <span className="term__content">
                        <p>facilitates illegal activity;</p>
                      </span>
                    </li>
                    <li>
                      <span className="indicator indicator--sub">(iii)</span>
                      <span className="term__content">
                        <p>depicts sexually explicit images;</p>
                      </span>
                    </li>
                    <li>
                      <span className="indicator indicator--sub">(iv)</span>
                      <span className="term__content">
                        <p>promotes unlawful violence;</p>
                      </span>
                    </li>
                    <li>
                      <span className="indicator indicator--sub">(v)</span>
                      <span className="term__content">
                        <p>constitutes unsolicited bulk email, junk mail or spam;</p>
                      </span>
                    </li>
                    <li>
                      <span className="indicator indicator--sub">(vi)</span>
                      <span className="term__content">
                        <p>is discriminatory based on race, gender, colour, religious belief, sexual orientation, disability, or any other illegal activity;</p>
                      </span>
                    </li>
                    <li>
                      <span className="indicator indicator--sub">(vii)</span>
                      <span className="term__content">
                        <p>are false including without limitation false names, addresses and contact details;</p>
                      </span>
                    </li>
                    <li>
                      <span className="indicator indicator--sub">(viii)</span>
                      <span className="term__content">
                        <p>which are in breach of any person's intellectual property or privacy rights; or</p>
                      </span>
                    </li>
                    <li>
                      <span className="indicator indicator--sub">(ix)</span>
                      <span className="term__content">
                        <p>causes damage or injury to any person or property,</p>
                      </span>
                    </li>

                    <p>and we reserve the right, without liability to you, to disable your access to any material that breaches the provisions of this Clause.</p>
                  </ul>
                </span>
              </li>
            </ul>
          </span>
        </li>
      </ul>

      <ul className="term__list-contents">
        <li>
          <span className="indicator">10.</span>
          <span className="term__sub-title"><p>healthcare provider's data</p></span>
        </li>

        <li>
          <span className="indicator">10.1</span>
          <span className="term__content">
            <p>You acknowledge and agree to provide current, accurate and up-to-date materials, information and data about yourself as required.</p>
          </span>
        </li>

        <li>
          <span className="indicator">10.2</span>
          <span className="term__content">
            <p>We are not responsible for any of your materials, information or data which is stored in our system nor do we exert any editorial or other subjective control over such materials, information or data.</p>
          </span>
        </li>

        <li>
          <span className="indicator">10.3</span>
          <span className="term__content">
            <p>You acknowledge and agree to accept that any information provided by us is general information and is not in the nature of advice. We derive our information from sources which we believe to be accurate and up to date as at the date of publication and reserve the right to update this information at any time.</p>
          </span>
        </li>
      </ul>

      <ul className="term__list-contents">
        <li>
          <span className="indicator">11.</span>
          <span className="term__sub-title"><p>healthcare provider's obligations</p></span>
        </li>

        <li>
          <span className="indicator">11.1</span>
          <span className="term__content">
            <p>You shall use your best endeavours to honour all Appointments made.</p>
          </span>
        </li>

        <li>
          <span className="indicator">11.2</span>
          <span className="term__content">
            <p>You shall be responsible for procuring and maintaining any communications networks, equipment, application and/or ancillary services needed to connect to, access or otherwise use the Services and for ensuring that such communications networks, equipment, application and/or ancillary services is compatible with Services.</p>
          </span>
        </li>

        <li>
          <span className="indicator">11.3</span>
          <span className="term__content">
            <p>You warrant that you have and will maintain all necessary licenses, consents and permissions necessary for the performance of your obligations under this Agreement.</p>
          </span>
        </li>

        <li>
          <span className="indicator">11.4</span>
          <span className="term__content">
            <p>You warrant that you shall at all times comply with all related medical and healthcare regulations and be in good standing with the relevant registration authority.</p>
          </span>
        </li>

        <li>
          <span className="indicator">11.5</span>
          <span className="term__content">
            <p>You shall be responsible to renew the Annual Practising Certificate in a timely manner and update us within thirty (30) days.</p>
          </span>
        </li>

        <li>
          <span className="indicator">11.6</span>
          <span className="term__content">
            <p>You shall from time to time update your profile on the Site and Application with the most current and accurate information including but not limited to qualifications and credentials, practice locations, education, hospital affiliations, languages, insurance and corporate panels.</p>
          </span>
        </li>
      </ul>

      <ul className="term__list-contents">
        <li>
          <span className="indicator">12.</span>
          <span className="term__sub-title"><p>restrictions</p></span>
        </li>

        <li>
          <span className="indicator">12.1</span>
          <span className="term__content">
            <p>Except to the extent and in the circumstances expressly required to be permitted by us or by law, you shall and shall procure the Healthcare Provider Staff:</p>

            <ul>
              <li>
                <span className="indicator indicator--sub">(a)</span>
                <span className="term__content">
                  <p>not to alter copy, modify, adapt, publish, transmit, create derivative works from, mirror, download, reproduce, distribute, display, sell, sub-license, commercially exploit, or translate the whole or any part of the Services and/or Documentation in any way whatsoever;</p>
                </span>
              </li>
              <li>
                <span className="indicator indicator--sub">(b)</span>
                <span className="term__content">
                  <p>not to permit the whole or any part of the Services and/or Documentation to be combined with or become incorporated in any other computer programs nor decompile disassemble, reverse engineer or reduce to human-perceivable form the same nor attempt to do any of such things;</p>
                </span>
              </li>
              <li>
                <span className="indicator indicator--sub">(c)</span>
                <span className="term__content">
                  <p>not to express or imply any statements you make are endorsed by us without our specific prior written consent;</p>
                </span>
              </li>
              <li>
                <span className="indicator indicator--sub">(d)</span>
                <span className="term__content">
                  <p>not to use all or any part of the Services and/or Documentation in order to build a product or service which competes with the Services;</p>
                </span>
              </li>
              <li>
                <span className="indicator indicator--sub">(e)</span>
                <span className="term__content">
                  <p>not to use the Services and/or Documentation to provide Services to third parties nor shall it make the Services and/or Documentation available to unauthorised third parties or attempt to obtain, or assist third parties in obtaining, access to the Services and/or Documentation;</p>
                </span>
              </li>
              <li>
                <span className="indicator indicator--sub">(f)</span>
                <span className="term__content">
                  <p>use all reasonable endeavours to prevent any unauthorised access to, or use of, the Services and/or the Documentation and, in the event of any such unauthorised access or use, promptly notify us;</p>
                </span>
              </li>
              <li>
                <span className="indicator indicator--sub">(g)</span>
                <span className="term__content">
                  <p>not to remove or modify any notice of our proprietary rights;</p>
                </span>
              </li>
              <li>
                <span className="indicator indicator--sub">(h)</span>
                <span className="term__content">
                  <p>not to perform or disclose any benchmark or performance tests of the Services without our prior written consent;</p>
                </span>
              </li>
              <li>
                <span className="indicator indicator--sub">(i)</span>
                <span className="term__content">
                  <p>refrain from attempting to circumvent our security or network including accessing data not intended for you, logging into a server or account you are not expressly authorised to access, or probing the security of other networks (such as running a port scan);</p>
                </span>
              </li>
              <li>
                <span className="indicator indicator--sub">(j)</span>
                <span className="term__content">
                  <p>not to access or use the Services in such a way as to, or commit any act that would or does, impose an unreasonable or disproportionately large load on our infrastructure;</p>
                </span>
              </li>
              <li>
                <span className="indicator indicator--sub">(k)</span>
                <span className="term__content">
                  <p>not to execute any form of network monitoring which will intercept data not intended for you;</p>
                </span>
              </li>
              <li>
                <span className="indicator indicator--sub">(l)</span>
                <span className="term__content">
                  <p>not to engage in any unlawful activity in connection with the use of the Services;</p>
                </span>
              </li>
              <li>
                <span className="indicator indicator--sub">(m)</span>
                <span className="term__content">
                  <p>not to engage in any conduct which restricts or inhibits any other users from properly using or enjoying the Services;</p>
                </span>
              </li>
              <li>
                <span className="indicator indicator--sub">(n)</span>
                <span className="term__content">
                  <p>not to frame or use framing techniques to attach any of our proprietary information (including images, text, page layout or form) without our express consent;</p>
                </span>
              </li>
              <li>
                <span className="indicator indicator--sub">(o)</span>
                <span className="term__content">
                  <p>not to use any meta tags or other “hidden text” utilizing our proprietary information without our express consent;</p>
                </span>
              </li>
              <li>
                <span className="indicator indicator--sub">(p)</span>
                <span className="term__content">
                  <p>not to use any code or other devices containing any reference to us, the Site or Application and/or the Services to direct persons to any other Site, Application and/or Services;</p>
                </span>
              </li>
              <li>
                <span className="indicator indicator--sub">(q)</span>
                <span className="term__content">
                  <p>not to use any automated process of any sort to query, access or copy any material on the Services or generate or compile any document or database based on the material published on the Services;</p>
                </span>
              </li>
              <li>
                <span className="indicator indicator--sub">(r)</span>
                <span className="term__content">
                  <p>comply with and shall not breach all laws, rules, regulations and/or third party rights;</p>
                </span>
              </li>
              <li>
                <span className="indicator indicator--sub">(s)</span>
                <span className="term__content">
                  <p>not to interfere with or disrupt the operation of the Services and/or the servers or network used to make the Services available; or violate any requirements, procedures, policies or regulations of such networks;</p>
                </span>
              </li>
              <li>
                <span className="indicator indicator--sub">(t)</span>
                <span className="term__content">
                  <p>not to use any robot, spider, scraper or other automated means to access the Services for any purpose.</p>
                </span>
              </li>
            </ul>
          </span>
        </li>

        <li>
          <span className="indicator">12.2</span>
          <span className="term__content">
            <p>The provision contained in Clause 12.1 is a non-exhaustive list of prohibited activities which you shall not engage in with respect to the Site, Application and/or Services. We reserve the right to amend this list from time to time.</p>
          </span>
        </li>
      </ul>

      <ul className="term__list-contents">
        <li>
          <span className="indicator">13.</span>
          <span className="term__sub-title"><p>suspension and modifications</p></span>
        </li>

        <li>
          <span className="indicator">13.1</span>
          <span className="term__content">
            <p>We may upon providing you a notice, suspend your access to the Services:</p>

            <ul>
              <li>
                <span className="indicator indicator--sub">(a)</span>
                <span className="term__content">
                  <p>in the event you are in breach of any of the terms and conditions of this Agreement (including without limitation your failure to comply with the payment obligations);</p>
                </span>
              </li>
              <li>
                <span className="indicator indicator--sub">(b)</span>
                <span className="term__content">
                  <p>in the event that you engage in inappropriate or unprofessional conduct;</p>
                </span>
              </li>
              <li>
                <span className="indicator indicator--sub">(c)</span>
                <span className="term__content">
                  <p>to comply with laws and regulations; or</p>
                </span>
              </li>
              <li>
                <span className="indicator indicator--sub">(d)</span>
                <span className="term__content">
                  <p>in the event we are of the view that your access or use of the Services poses an imminent security risk or may subject us to liability.</p>
                </span>
              </li>
            </ul>
          </span>
        </li>

        <li>
          <span className="indicator">13.2</span>
          <span className="term__content">
            <p>It may be necessary for us to perform scheduled or unscheduled repairs or maintenance, or remotely patch or upgrade the Services, which may temporarily degrade the quality of the Services or result in a partial or complete outage of Services. We will not be liable to you or any third party for any degradation in the quality of the Services or outage of Services under any circumstances whatsoever.</p>
          </span>
        </li>

        <li>
          <span className="indicator">13.3</span>
          <span className="term__content">
            <p>We may modify the functionality or features of the Services at any time. In this regard, we will not be liable to you or any third party for any such modification.</p>
          </span>
        </li>
      </ul>

      <ul className="term__list-contents">
        <li>
          <span className="indicator">14.</span>
          <span className="term__sub-title"><p>exclusions</p></span>
        </li>

        <li>
          <span className="indicator">14.1</span>
          <span className="term__content">
            <p>You hereby acknowledge that the Services have not been prepared to meet your individual requirements and that it is therefore your responsibility to ensure that the facilities and functions described in the Documentation meet your requirements. We shall not be liable for any failure of the Services and the Software to provide any facility or function not specified in the Documentation.</p>
          </span>
        </li>

        <li>
          <span className="indicator">14.2</span>
          <span className="term__content">
            <p>The Services is provided on an “as is” and “as available” basis. All warranties whether expressed or implied, or any implied warranty of merchantability or fitness for particular purposes (including without limitation, that the operation or use of the Services shall be uninterrupted or error free) are hereby excluded to the fullest extent permitted by law.</p>
          </span>
        </li>

        <li>
          <span className="indicator">14.3</span>
          <span className="term__content">
            <p>We are not responsible for any delays, delivery failures, or any other loss or damage resulting from the transfer of data over communications networks and facilities, including the internet, and you hereby acknowledge that the Services and the Documentation may be subject to limitations, delays and other problems inherent in the use of such communications facilities.</p>
          </span>
        </li>

        <li>
          <span className="indicator">14.4</span>
          <span className="term__content">
            <p>You acknowledge that:</p>

            <ul>
              <li>
                <span className="indicator indicator--sub">(a)</span>
                <span className="term__content">
                  <p>prior to entering into this Agreement you have been given a reasonable opportunity to examine and satisfy yourself regarding Services which are the subject of this Agreement and that prior to entering into this Agreement you have availed yourself of that opportunity; and</p>
                </span>
              </li>
              <li>
                <span className="indicator indicator--sub">(b)</span>
                <span className="term__content">
                  <p>at no time prior to entering into this Agreement have you relied on our skill or judgment and that it would be unreasonable for you to do so.</p>
                </span>
              </li>
            </ul>
          </span>
        </li>
      </ul>

      <ul className="term__list-contents">
        <li>
          <span className="indicator">15.</span>
          <span className="term__sub-title"><p>termination</p></span>
        </li>

        <li>
          <span className="indicator">15.1</span>
          <span className="term__content">
            <p>We may terminate this Agreement forthwith on giving notice to you if:</p>

            <ul>
              <li>
                <span className="indicator indicator--sub">(a)</span>
                <span className="term__content">
                  <p>your Annual Practising Certificate has been revoked and such termination shall be immediate;</p>
                </span>
              </li>
              <li>
                <span className="indicator indicator--sub">(b)</span>
                <span className="term__content">
                  <p>you have committed a material breach of any of the terms and conditions of this Agreement and (in the case of a breach capable of being remedied) shall have failed, within fourteen (14) days after the receipt of a request in writing from us to do so, to remedy the breach; or</p>
                </span>
              </li>
              <li>
                <span className="indicator indicator--sub">(c)</span>
                <span className="term__content">
                  <p>you have a receiver or administrator appointed on you or over any part of your undertaking or assets or shall pass a resolution for winding up (otherwise than for the purpose of a bona fide scheme of solvent amalgamation or reconstruction) or a court of competent jurisdiction shall make an order to that effect or if you shall enter into any voluntary arrangement with your creditors or shall become subject to an administration order or shall cease to carry on business.</p>
                </span>
              </li>
            </ul>
          </span>
        </li>

        <li>
          <span className="indicator">15.2</span>
          <span className="term__content">
            <p>We reserve the right to terminate this Agreement immediately without assigning any reason by providing thirty (30) days’ prior written notice.</p>
          </span>
        </li>
      </ul>

      <ul className="term__list-contents">
        <li>
          <span className="indicator">16.</span>
          <span className="term__sub-title"><p>consequence of termination</p></span>
        </li>

        <li>
          <span className="indicator">16.1</span>
          <span className="term__content">
            <p>Forthwith upon the termination of this Agreement, all licenses granted to you under this Agreement shall be terminated. In this regard, your access to and use of the Services shall be terminated. In addition to the foregoing, we may delete your materials, information or data stored in our system following any termination pursuant to Clause 15.</p>
          </span>
        </li>

        <li>
          <span className="indicator">16.2</span>
          <span className="term__content">
            <p>You shall return and make no further use of any equipment, property, Documentation and other items (all copies of them) belonging to us.</p>
            <p>Any termination of this Agreement (howsoever occasioned) shall not affect any of our accrued rights or liabilities nor shall it affect the coming into force or the continuance in force of any provision hereof which is expressly or by implication intended to come into or continue in force on or after such termination. There shall be no refund of any part of the Administrative Charges upon the termination of this Agreement, provided that we reserve the right to consider a request for refund on a case by case basis.</p>
          </span>
        </li>
      </ul>

      <ul className="term__list-contents">
        <li>
          <span className="indicator">17.</span>
          <span className="term__sub-title"><p>indemnity</p></span>
        </li>

        <li>
          <span className="indicator">17.1</span>
          <span className="term__content">
            <p>You will indemnify and hold us (and our officers, directors, agent, subsidiaries, joint ventures and employees), harmless from all losses and damage suffered by us and any claim or demand, including reasonable legal fees, made by any third party due to, arising out of your negligence, breach of this Agreement or your violation of any law or the rights of any third party.</p>
          </span>
        </li>
      </ul>

      <ul className="term__list-contents">
        <li>
          <span className="indicator">18.</span>
          <span className="term__sub-title"><p>liability</p></span>
        </li>

        <li>
          <span className="indicator">18.1</span>
          <span className="term__content">
            <p>Consideration should always be given to the nature of internet transactions and in recognition of the above, you waive any claim you may have against us that is in any way connected with a dispute you have with another user of the Services (including without limitation a User) and you agree to indemnify us for any losses or liability we suffer as a result of any claim against us by another user or any other third party as a result of your dispute or in relation to your dealings with such other user or third party.</p>
          </span>
        </li>

        <li>
          <span className="indicator">18.2</span>
          <span className="term__content">
            <p>Your acceptance of this Agreement also acts as a general release of us, any of our affiliates and/or subsidiaries (and all of our officers, directors, agents and employees) from any liability for any claims, loss or damages (both direct and indirect, including loss of profits, goodwill and business opportunity) arising out of or in any way connected to your access to and use of the Services.</p>
          </span>
        </li>

        <li>
          <span className="indicator">18.3</span>
          <span className="term__content">
            <p>Our maximum liability to you and your business in respect of your use of the Services will be the amount of Administrative Charges paid by you during the year in which the liability arose. You further agree that we shall have no liability for indirect or consequential losses, loss of data, income or profits or damages for loss of or damage to property.</p>
          </span>
        </li>
      </ul>

      <ul className="term__list-contents">
        <li>
          <span className="indicator">19.</span>
          <span className="term__sub-title"><p>protection of personal data</p></span>
        </li>

        <li>
          <span className="indicator">19.1</span>
          <span className="term__content">
            <p>You shall comply at all times with the Personal Data Protection Act 2010 (“Data Protection Legislation”) and shall not perform your obligations under this Agreement in such a way as to cause us to breach any of our applicable obligations under the Data Protection Legislation.</p>
          </span>
        </li>
      </ul>

      <ul className="term__list-contents">
        <li>
          <span className="indicator">20.</span>
          <span className="term__sub-title"><p>exclusivity</p></span>
        </li>

        <li>
          <span className="indicator">20.1</span>
          <span className="term__content">
            <p>You agree that during the term of this Agreement, you shall not engage directly or indirectly with individuals/entities that provide the same or similar online and mobile technological services as the Site or Application.</p>
          </span>
        </li>
      </ul>

      <ul className="term__list-contents">
        <li>
          <span className="indicator">21.</span>
          <span className="term__sub-title"><p>governing law</p></span>
        </li>

        <li>
          <span className="indicator">21.1</span>
          <span className="term__content">
            <p>This Agreement (and any dispute, controversy, proceedings or claim of whatever nature arising out of or in any way relating to them or their formation) shall be governed by and interpreted in accordance with Malaysian law and, for these purposes, the parties irrevocably submit to the exclusive jurisdiction of the Malaysian courts.</p>
          </span>
        </li>
      </ul>

      <ul className="term__list-contents">
        <li>
          <span className="indicator">22.</span>
          <span className="term__sub-title"><p>variations</p></span>
        </li>

        <li>
          <span className="indicator">22.1</span>
          <span className="term__content">
            <p>We reserve the right at any time to revise the content of the Services and this Agreement. Any changes to this Agreement will be posted on&nbsp;<a href="dr.bookdoc.com">dr.bookdoc.com</a>&nbsp;and a notice will be provided on the Site. By continuing to use the Services following any such change you will signify that you agree to be bound by the revised Agreement.</p>
          </span>
        </li>
      </ul>

      <ul className="term__list-contents">
        <li>
          <span className="indicator">23.</span>
          <span className="term__sub-title"><p>events beyond health4U's control</p></span>
        </li>

        <li>
          <span className="indicator">23.1</span>
          <span className="term__content">
            <p>We shall not be liable to you for any breach of this Agreement or any failure to provide or delay in providing the Services resulting from any event or circumstance beyond our reasonable control including, without limitation, strikes, lock-outs and other industrial disputes, breakdown or congestion of systems or network access and/or network services, fire, explosion or accident.</p>
          </span>
        </li>
      </ul>

      <ul className="term__list-contents">
        <li>
          <span className="indicator">24.</span>
          <span className="term__sub-title"><p>entire agreement</p></span>
        </li>

        <li>
          <span className="indicator">24.1</span>
          <span className="term__content">
            <p>This Agreement and the Registration Form supersedes any previous agreement between the parties in relation to the matters dealt with herein and represents the entire understanding between the parties in relation thereto. Any and all representations, covenants, undertakings, warranties and agreements whether verbal or in writing prior hereto are hereby rescinded nullified and superseded.</p>
          </span>
        </li>
      </ul>

      <ul className="term__list-contents">
        <li>
          <span className="indicator">25.</span>
          <span className="term__sub-title"><p>no waiver</p></span>
        </li>

        <li>
          <span className="indicator">25.1</span>
          <span className="term__content">
            <p>No failure or delay on our part in exercising nor any omission to exercise any right, power, privilege or remedy accruing to either party under this Agreement upon any default on your part shall impair any such right power privilege or remedy or be construed as a waiver thereof or any acquiescence in such default nor shall any action by us in respect of any default or any acquiescence in any such default affect or impair any of our right power privilege or remedy in respect of any other or subsequent default.</p>
          </span>
        </li>
      </ul>

      <ul className="term__list-contents">
        <li>
          <span className="indicator">26.</span>
          <span className="term__sub-title"><p>rights and remedies</p></span>
        </li>

        <li>
          <span className="indicator">26.1</span>
          <span className="term__content">
            <p>The rights and remedies provided in this Agreement are cumulative and not exclusive of any rights or remedies provided by law. For the avoidance of doubt, in the event of any breach or threatened breach of any term herein, each party hereto shall be entitled to claim any and all equitable remedies available to it subject to applicable laws.</p>
          </span>
        </li>
      </ul>

      <ul className="term__list-contents">
        <li>
          <span className="indicator">27.</span>
          <span className="term__sub-title"><p>severability</p></span>
        </li>

        <li>
          <span className="indicator">27.1</span>
          <span className="term__content">
            <p>If any provision of this Agreement is held invalid, unenforceable or illegal for any reason, this Agreement shall remain otherwise in full force apart from such provision which shall be deemed deleted.</p>
          </span>
        </li>
      </ul>

      <ul className="term__list-contents">
        <li>
          <span className="indicator">28.</span>
          <span className="term__sub-title"><p>notices</p></span>
        </li>

        <li>
          <span className="indicator">28.1</span>
          <span className="term__content">
            <p>All notices pursuant to this Agreement given by you to us shall be delivered personally or sent by acknowledge of receipt registered post or facsimile transmission to the address, facsimile number specified in the Registration Form. Any other form of communication given by you to us may, in addition to the foregoing methods of delivery, be made by way of electronic mail.</p>
          </span>
        </li>

        <li>
          <span className="indicator">28.2</span>
          <span className="term__content">
            <p>All notices pursuant to this Agreement given by us to you under this Agreement shall be delivered to you to the contact address you have provided to us in the Registration Form. Any other form of communication given by us to you may, in addition to the foregoing methods of delivery, be made by way of electronic mail.</p>
          </span>
        </li>
      </ul>

      <ul className="term__list-contents">
        <li>
          <span className="indicator">29.</span>
          <span className="term__sub-title"><p>assignment</p></span>
        </li>

        <li>
          <span className="indicator">29.1</span>
          <span className="term__content">
            <p>You may not assign, transfer or sublicense this Agreement to anyone else and any attempt to do so in violation of this section shall be null and void.</p>
          </span>
        </li>
      </ul>

      <ul className="term__list-contents">
        <li>
          <span className="indicator">30.</span>
          <span className="term__sub-title"><p>relationship of the parties</p></span>
        </li>

        <li>
          <span className="indicator">30.1</span>
          <span className="term__content">
            <p>Nothing in this Agreement is intended to create a partnership, or legal relationship of any kind that would impose liability upon one party for the act or failure to act of the other Party, or to authorise either party to act as agent for the other party. Neither party shall have authority to make representations, act in the name of, or on behalf of, or to otherwise bind the other Party.</p>
          </span>
        </li>
      </ul>

      <ul className="term__list-contents">
        <li>
          <span className="indicator">31.</span>
          <span className="term__sub-title"><p>further assurances</p></span>
        </li>

        <li>
          <span className="indicator">31.1</span>
          <span className="term__content">
            <p>You agree to do all things and execute all deeds, instruments, transfers or other documents as may be necessary or desirable to give full effect to the provisions of this Agreement and the transactions contemplated by it.</p>
          </span>
        </li>
      </ul>
    </div>
  );
}

export default Terms;